const Navbar = () => {
    return(
        <div className="navbar">
            <img className="logo" src='https://res.cloudinary.com/dtlrrlpag/image/upload/v1693403101/Eneyat/Eneyat_Ethiopian_Logo_RGB_PNG-01_xehnur.png' alt='img'/>
           
        </div>

    )
}

export default Navbar;